import { render } from "./ComponentTitle.vue?vue&type=template&id=10c01197"
import script from "./ComponentTitle.vue?vue&type=script&lang=js"
export * from "./ComponentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__